import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export type IniciarSolicitacaoReservaPayload = {
  contatoNome: string;
  contatoSobrenome: string;
  contatoCelular: string;
  contatoEmail: string;

  empreendId: number;
  dataIni: string; // ISO (YYYY-MM-DD ou full ISO)
  dataFim: string; // ISO

  aluguel?: number;
  troca?: number;
  compra?: number;
  venda?: number;

  precoBaseProprietario: number;
  valorPropostoClienteInicial: number;
  validadeDias?: number;
};

export type IniciarSolicitacaoReservaResponse = {
  solicitacaoReservaId: number;
  token: string;
};

export type HospedeSolicitacaoReserva = {
  pessoaId: number;
  nome: string;
  sobrenome?: string | null;
  cpf?: string | null;
  dataNascimento: string | null; // ou Date, depende do seu backend
  titular: boolean;
};

export type BuscarHospedesByTokenResponse = {
  hospedes: HospedeSolicitacaoReserva[];
};
export type SalvarAceiteTermosPorTokenPayload = {
  aceitouTermosUso: boolean;
  aceitouPoliticaPrivacidade: boolean;
  aceitouTermoTaxa: boolean;
};


export const iniciarSolicitacaoReservaService = async (
  payload: IniciarSolicitacaoReservaPayload
): Promise<IniciarSolicitacaoReservaResponse | null> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/iniciar-solicitacao-reserva`;
  console.log("Payload para iniciar solicitação de reserva:", payload);

  try {
    const response = await axios.post(URL, payload, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    console.log("Resposta do servidor ao iniciar solicitação de reserva:", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export type StatusSolicitacaoReserva =
  | "CRIADA"
  | "SR_ENVIADA"
  | "INICIADA"
  | "AGUARDANDO_PAGAMENTO_TAXA"
  | "PAGAMENTO_TX_INTERROMPIDO"
  | "TAXA_PAGA"
  | "AGUARDANDO_ESTORNO"
  | "ESTORNADO"
  | "FINALIZADO_FRACASSO"
  | "NAO_TEM_MAIS_INTERESSE"
  | "SEM_INTERESSE_PERIODO_PROCURADO"
  | "SEM_INTERESSE_PERIODO_ENCONTRADO"
  | "EM_VERIFICACAO"
  | "RESERVA_CONFIRMADA"
  | "RESERVA_FINALIZADA"
  | "RESERVA_CANCELADA";

export type BuscarSolicitacaoPorTokenResponse = {
  solicitacaoReserva: {
    id: number;
    token: string;
    contatoNome: string;
    contatoSobrenome: string;
    contatoCelular: string;
    contatoEmail: string;
    formaPagamentoPreferida?: "PIX" | "CARTAO" | null;
    status?: StatusSolicitacaoReserva | null;

    aceitouTermosUso?: boolean | null;
    aceitouPoliticaPrivacidade?: boolean | null;
    aceitouTermoTaxa?: boolean | null;
    aceiteTermosEm?: string | null;

    empreendimento?: {
      id: number;
      nome: string;
    } | null;

    periodoProcura?: {
      checkin: string | null;
      checkout: string | null;
      noites: number | null;
    } | null;
  };
};
export type SalvarFormaPagamentoByTokenPayload = {
  formaPagamento: "PIX" | "CARTAO";
};
export type AtualizarContatoSolicitacaoPayload = {
  contatoNome: string;
  contatoSobrenome: string;
  contatoCelular: string; // +E164
  contatoEmail: string;
};
export type ResumoEstadiaByTokenResponse = {
  empreendimento: { id: number; nome: string };
  checkin: string;   // ISO
  checkout: string;  // ISO
  noites: number;

  valorBaseEstimado: number;
  precificacaoCalculadaEm: string;

  taxaCondicional: number;
  linkPagamentoTaxa?: string;

  pix: {
    total: number;
    descontoMin: number;
    totalRestante: number;
  };

  cartao: {
    totalBruto: number;
    ajusteComercial: number;
    totalFinal: number;
    parcelas: number;
    valorParcela: number;

    totalRestanteFinal: number;
    valorParcelaRestante: number;
  };
   limitePosCheckin?: {
    status: "LIBERADO" | "BLOQUEADO";
    parcelasPosRegra: number;
    parcelasPosPermitidas: number;
    valorPosCheckin: number;
    limiteDisponivel: number;
    mensagem: string;
  };


  observacaoValorPodeMudar: boolean;
  mensagemValorPodeMudar?: string;
};

export const buscarSolicitacaoReservaPorTokenService = async (
  token: string
): Promise<BuscarSolicitacaoPorTokenResponse | null> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}`;

  try {
    const response = await axios.get(URL, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
export const salvarFormaPagamentoPorTokenService = async (
  token: string,
  payload: SalvarFormaPagamentoByTokenPayload
): Promise<boolean> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/forma-pagamento`;
  try {
    await axios.patch(URL, payload); // rota pública por token
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};



export const atualizarContatoSolicitacaoReservaService = async (
  solicitacaoReservaId: number,
  payload: AtualizarContatoSolicitacaoPayload
): Promise<boolean> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${solicitacaoReservaId}`;

  try {
    await axios.patch(URL, payload, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });
    return true;
  } catch (error: any) {
        console.error("buscarSolicitacaoReservaPorTokenService", {
          status: error?.response?.status,
          data: error?.response?.data,
          message: error?.message,
        });
  return false;
}
};

export const atualizarContatoSolicitacaoReservaPorTokenService = async (
  token: string,
  payload: AtualizarContatoSolicitacaoPayload
): Promise<boolean> => {
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/contato`;

  try {
    await axios.patch(URL, payload); // sem Authorization mesmo
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const salvarAceiteTermosPorTokenService = async (
  token: string,
  payload: SalvarAceiteTermosPorTokenPayload
): Promise<boolean> => {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/aceite-termos`;

  try {
    await axios.patch(url, payload);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};



export const buscarResumoEstadiaByTokenService = async (
  token: string
): Promise<ResumoEstadiaByTokenResponse | null> => {
  
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/resumo-estadia`;

  console.log("Buscando resumo da estadia por token:", token);
  try {
    const response = await axios.get(URL, {
      
    });
    console.log("Resposta do servidor ao buscar resumo da estadia por token:", response.data);
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export async function upsertHospedesSolicitacaoReservaPorTokenService(
  token: string,
  payload: { hospedes: any[] }
) {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/hospedes`;
  const resp = await axios.put(url, payload);
  return resp.data;
}

export async function buscarHospedesSolicitacaoReservaPorTokenService(
  token: string
): Promise<HospedeSolicitacaoReserva[]> {
  const url = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/hospedes`;
  try {
    const resp = await axios.get(url); // rota pública
    if (Array.isArray(resp.data)) {
      return resp.data;
    }

    if (Array.isArray(resp.data?.hospedes)) {
      return resp.data.hospedes;
    }

    return [];
  } catch (e) {
    console.error(e);
    return [];
  }
}

export type ListarSolicitacoesReservaParams = {
  contato?: string;
  empreendimento?: string;
  status?: StatusSolicitacaoReserva;
};

type EmpreendimentoResumo = {
  id: number;
  nome: string;
} | null;

type PeriodoProcuraResumo = {
  checkin: string | null;
  checkout: string | null;
  noites: number | null;
};





export type SolicitacaoReservaListItem = {
  id: number;
  token: string;
  numeroProtocolo?: string | null;
  pessoaId: number;
  empreendId: number;
  status: StatusSolicitacaoReserva;
  contatoNome: string;
  contatoSobrenome: string;
  contatoCelular: string;
  contatoEmail: string;
  formaPagamentoPreferida?: "PIX" | "CARTAO" | null;
  validadeProposta?: string | null;
  valorTaxa?: number | null;
  created_at?: string;
  updated_at?: string;

  empreendimento?: {
    id: number;
    nome: string;
  } | null;

  periodoProcura?: {
    checkin: string | null;
    checkout: string | null;
    noites: number | null;
  } | null;
};

export type BuscarSolicitacaoReservaByIdResponse = SolicitacaoReservaListItem & {
  origemProcura?: string;
  procuraId?: number;
  origemEntrada?: string;
  precoBaseProprietario?: number;
  valorPropostoClienteInicial?: number;
  valorPropostoClienteAtual?: number | null;
  valorPropostoClienteConfirmado?: number | null;
  aceitouTermosUso?: boolean | null;
  aceitouPoliticaPrivacidade?: boolean | null;
  aceitouTermoTaxa?: boolean | null;
  aceiteTermosEm?: string | null;
  formaPagamentoDefinidaEm?: string | null;
  numeroProtocolo?: string | null;
};

export const listarSolicitacoesReservaService = async (
  params?: ListarSolicitacoesReservaParams
): Promise<SolicitacaoReservaListItem[]> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva`;

  try {
    const response = await axios.get(URL, {
      params,
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("listarSolicitacoesReservaService", error);
    return [];
  }
};

export const buscarSolicitacaoReservaByIdService = async (
  id: number
): Promise<BuscarSolicitacaoReservaByIdResponse | null> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${id}`;

  try {
    const response = await axios.get(URL, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    return response.data ?? null;
  } catch (error) {
    console.error("buscarSolicitacaoReservaByIdService", error);
    return null;
  }
};

export const alterarStatusSolicitacaoService = async (
  id: number,
  status: StatusSolicitacaoReserva
): Promise<boolean> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${id}/status`;

  console.log("🔄 Tentando alterar status:", { id, status, URL, hasToken: !!Token });

  if (!Token) {
    console.error("❌ Token de autenticação não encontrado");
    return false;
  }

  try {
    const response = await axios.patch(URL, { status }, {
      headers: { Authorization: Token.AuthStr },
    });

    console.log("✅ Status alterado com sucesso:", response.data);
    return true;
  } catch (error: any) {
    console.error("❌ Erro ao alterar status:", {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
      url: URL,
      payload: { status }
    });

    // Log específico para erro 404
    if (error?.response?.status === 404) {
      console.error("🚨 Endpoint não encontrado! Verifique se a rota existe no backend:", URL);
    }

    return false;
  }
};

export const estornarPagamentoTaxaSolicitacaoPorTokenService = async (
  token: string
): Promise<boolean> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/by-token/${token}/pagamento-taxa/estorno`;

  if (!Token) {
    console.error("Token de autenticação não encontrado para estorno da taxa");
    return false;
  }

  try {
    await axios.post(
      URL,
      {},
      {
        headers: { Authorization: Token.AuthStr },
      }
    );
    return true;
  } catch (error) {
    console.error("estornarPagamentoTaxaSolicitacaoPorTokenService", error);
    return false;
  }
};

export type AndamentoSolicitacao = {
  id: number;
  created_at: string;
  tipo: 'STATUS_ALTERADO' | 'PAGAMENTO_REALIZADO' | 'EMAIL_ENVIADO' | 'CONTATO_ATUALIZADO' | 'SOLICITACAO_CRIADA' | 'TAXA_PAGA' | 'RESERVA_CONFIRMADA';
  descricao: string;
  usuario?: string;
  criadoPor?: {
    tipo: string;
    nome?: string;
    em?: string;
  };
  dadosAdicionais?: any;
};

export const buscarAndamentosSolicitacaoService = async (
  id: number
): Promise<AndamentoSolicitacao[]> => {
  if (!id || id <= 0) {
    console.warn("❌ ID inválido para buscar andamentos:", id);
    return [];
  }

  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${id}/andamentos`;

  console.log(`🔍 Buscando andamentos de SR #${id} em: ${URL}`);

  try {
    const response = await axios.get(URL, {
      headers: Token ? { Authorization: Token.AuthStr } : undefined,
    });

    if (!response || !response.data) {
      console.warn("⚠️ Resposta vazia do servidor");
      return [];
    }

    let data = response.data;

    // Suporta múltiplas estruturas de resposta
    if (data && typeof data === "object" && !Array.isArray(data)) {
      data = data.andamentos || data.data || data.resultado || [];
    }

    // Garante que é um array
    if (!Array.isArray(data)) {
      console.warn("⚠️ Resposta não é um array, convertendo...", data);
      data = [];
    }

    console.log(`✅ ${data.length} andamento(s) recebido(s):`, data);
    
    // Debug detalhado de cada andamento
    data.forEach((andamento: any, idx: number) => {
      console.log(`  [${idx}] tipo: ${andamento.tipo}, usuario: ${andamento.usuario || 'SEM USUÁRIO'}, descricao: ${andamento.descricao}`);
    });

    // Retorna ordenado por data (mais recente primeiro)
    return (data as AndamentoSolicitacao[])
      .filter((item) => item && item.id) // Remove items inválidos
      .sort((a: AndamentoSolicitacao, b: AndamentoSolicitacao) => {
        try {
          const dataA = a.created_at ? new Date(a.created_at).getTime() : 0;
          const dataB = b.created_at ? new Date(b.created_at).getTime() : 0;
          return dataB - dataA;
        } catch (error) {
          console.warn("⚠️ Erro ao ordenar datas:", error);
          return 0;
        }
      });
  } catch (error: any) {
    const statusCode = error?.response?.status;
    const errorData = error?.response?.data;

    console.error(`❌ Erro ${statusCode || "desconhecido"} ao buscar andamentos:`, error.message);

    if (statusCode === 404) {
      console.warn("ℹ️ Solicitação não encontrada (404)");
    } else if (statusCode === 401) {
      console.warn("ℹ️ Token inválido ou expirado (401)");
    } else {
      console.error("📋 Detalhes do erro:", errorData);
    }

    return [];
  }
};

// Função de diagnóstico para testar conectividade
export const testarEndpointStatus = async (id: number): Promise<{ sucesso: boolean; mensagem: string }> => {
  const Token = validateToken();
  const URL = `${Globais.DOMINIOBACK}/solicitacoes-reserva/${id}/status`;

  console.log("🔍 Testando endpoint:", URL);

  if (!Token) {
    return { sucesso: false, mensagem: "Token de autenticação não encontrado" };
  }

  try {
    // Primeiro tenta um GET para ver se o endpoint existe
    const response = await axios.get(URL.replace('/status', ''), {
      headers: { Authorization: Token.AuthStr },
    });

    return {
      sucesso: true,
      mensagem: `Endpoint acessível. Status atual: ${response.data?.status || 'desconhecido'}`
    };
  } catch (error: any) {
    console.error("❌ Erro no teste de endpoint:", error?.response);

    if (error?.response?.status === 404) {
      return { sucesso: false, mensagem: "Endpoint não encontrado (404). Verifique se a rota existe no backend." };
    }

    if (error?.response?.status === 401) {
      return { sucesso: false, mensagem: "Não autorizado (401). Token inválido ou expirado." };
    }

    return {
      sucesso: false,
      mensagem: `Erro ${error?.response?.status || 'desconhecido'}: ${error?.response?.data?.message || error?.message}`
    };
  }
};
